// Form initial values

export const initialValues = {
    cliente: {
        actividadEconomica: '',
        caracteristicaCliente:'',
        cargaFamiliar: 0,
        categoriaEspecial: '',
        cedulaRif: "",
        condicionVivienda:'',
        ciudadNacimiento: "",
        codigoOtraNacionalidad: "",
        estadoCivil: "",
        estadoNacimiento: "",
        fechaDesde: "",
        fechaNacimiento: "",
        fechaVencimiento: "",
        fechaVenceIdentificacion:'',
        // tipoCliente: '',
        lugarNacimiento: "",
        nacionalidad: "",
        nivelAcademico: "",
        nombre: "",
        nombreCompleto:'',
        nombreOficial: "bc217645",
        actividadEspecifica: "",
        oficina: "",
        modo: "I",
        pasaporte: '',
        primerApellido: "",
        profesion: "",
        retiene: "N",
        rif:'',
        tipoRif: '',
        segmento: 0,
        segundoApellido: "",
        sexo: "",
        subSegmento: 0,
        ultActualizaMis: "",
        tipoDocumento: ''
    },
};